export default "__VITE_ASSET__BUolzxeG__"